
define('text!samples/kickstart/GIST-README.ejs',[],function () { return 'This Gist has been created using [Rx Training Games](https://github.com/JulienMoumne/rx-training-games).\n\nThe JavaScript file can be imported and executed [here](<%= url %>) by pasting the current [Gist URL]().';});

